import cn from 'classnames';
import type { FC } from 'react';
import React, { memo } from 'react';

import { Text, Heading, Link } from '@sravni/react-design-system/lib/Typography';

import { TERMS_LINK } from './PhoneNumberCheckerLayout.config';
import styles from './PhoneNumberCheckerLayout.module.scss';
import { phoneNumberCheckerLayout } from './PhoneNumberCheckerLayout.text';

interface Props {
  termsLink?: string;
  className?: string;
}

export const PhoneNumberCheckerLayout: FC<Props> = memo(({ termsLink, children, className }) => (
  <div className={cn(styles.container, className)}>
    <Heading level={4}>{phoneNumberCheckerLayout.title}</Heading>

    {children}

    <Text className={styles.footerText} size={10}>
      {phoneNumberCheckerLayout.privacyAgreement}

      <Link href={termsLink} target="_blank" rel="noreferrer">
        &nbsp;{phoneNumberCheckerLayout.termsLink}
      </Link>
    </Text>
  </div>
));

PhoneNumberCheckerLayout.displayName = 'PhoneNumberCheckerLayout';

PhoneNumberCheckerLayout.defaultProps = {
  termsLink: TERMS_LINK,
};
